var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "video-1",
    d: "M15.1670013,0 L15.2577937,0.00352464879 C15.8571907,0.0502268793 16.3329987,0.555158816 16.3329987,1.16661648 L16.3329987,1.16661648 L16.3329987,5.25007529 L21,0.583609378 L21,13.4169929 L16.3329987,8.74992471 L16.3329987,12.8339858 L16.3294742,12.9247015 C16.2827739,13.5236388 15.7778766,14 15.1670013,14 L15.1670013,14 L1.16659975,14 L1.07580335,13.9964715 C0.47635436,13.9497199 0,13.4442963 0,12.8339858 L0,12.8339858 L0,1.16661648 L0.00352850023,1.07574073 C0.0502807869,0.475814905 0.555724446,0 1.16659975,0 L1.16659975,0 L15.1670013,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "video-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "video-4",
    xlinkHref: "#video-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "video-5",
    fill: "#000",
    points: "-3 17 23 17 23 -2 -3 -2",
    mask: "url(#video-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e4ba3317845be2d85ec38b8c076098b7.svg";
export { ForwardRef as ReactComponent };